import { buildProps, definePropType } from '@ll-plus/utils'

import type { CSSProperties, ExtractPropTypes } from 'vue'
import type Tooltip from './tooltip.vue'

// 弹窗定位的位置
export const placement = [
  'top',
  'left',
  'right',
  'bottom',
  'topLeft',
  'topRight',
  'bottomLeft',
  'bottomRight',
  'leftTop',
  'leftBottom',
  'rightTop',
  'rightBottom',
] as const
export const tooltipProps = buildProps({
  /**
   * @description 背景色
   */
  bgColor: {
    type: String,
    default: undefined,
  },
  /**
   * @description 文本色
   */
  textColor: {
    type: String,
    default: undefined,
  },
  /**
   * @description 是否为白色背景
   */
  isWhiteBg: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 是否显示提示弹窗箭头
   */
  arrow: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 提示语
   */
  tip: {
    type: String,
    default: '提示',
  },
  /**
   * @description 气泡框位置
   */
  placement: {
    type: String,
    values: placement,
    default: 'top',
  },
  /**
   * @description 容器的宽度
   */
  maxWidth: {
    type: definePropType<number | string>([Number, String]),
    default: '400px',
  },
  /**
   * @description 提示框里的文字是否超出显示...
   */
  tipEllipsis: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 提示框里的文字是否超出几行显示...
   */
  tipEllipsisLine: {
    type: Number,
    default: 1,
  },
  /**
   * @description 卡片类名
   */
  overlayClassName: {
    type: String,
  },
  /**
   * @description 卡片样式
   */
  overlayStyle: {
    type: Object,
  },
  /**
   * @description 文字是否超出显示...
   */
  ellipsis: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 文字的宽度，超出这个文字显示...
   */
  width: {
    type: definePropType<number | string>([Number, String]),
    default: '',
  },
  /**
   * @description 文字提示外层样式
   */
  containerStyle: {
    type: definePropType<CSSProperties>(Object),
    default: () => {},
  },

  // 显示tip外层div容器
  showContainer: {
    type: Boolean,
    default: true,
  },
} as const)

// props
export type TooltipProps = ExtractPropTypes<typeof tooltipProps> // ExtractPropTypes和defineCpmponent类似
export type PlacementType = TooltipProps['placement']

// instance
export type TooltipInstance = InstanceType<typeof Tooltip>
